export enum PillTypes {
  TAX_BOOKING_ENTITIES = 'TAX_BOOKING_ENTITIES',
  CURRENCIES = 'CURRENCIES',
  COMPANY_CODE = 'COMPANY_CODE',
  OBLIGATION = 'OBLIGATION',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
  PROVISION = 'PROVISION',
}

export const PillDefinitions = [
  { label: 'Company Codes', type: PillTypes.COMPANY_CODE },
  { label: 'Legal entity', type: PillTypes.LEGAL_ENTITY },
  { label: 'Currency Conversion Rates', type: PillTypes.CURRENCIES },
  { label: 'Obligation', type: PillTypes.OBLIGATION },
  { label: 'Provision', type: PillTypes.PROVISION },
  { label: 'Tax Booking Entities', type: PillTypes.TAX_BOOKING_ENTITIES },
];

export const getPillDefinitions = () => PillDefinitions;
